module.exports = __webpack_public_path__ + "img/AperoBalboa.05072d6.jpg";